module.exports = __webpack_public_path__ + "assets/images/games/bg_cloud_green.71d241b.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/games/carrot-game/bg_cloud_green.png
// module id = 1630
// module chunks = 1